function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#445896;}\n\t.st5{fill:#6AABE8;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st5",
  d: "M19.5,0.2h-16c-1.6,0-3,1.3-3,3v16c0,1.6,1.3,3,3,3h6.4c0,0,0,0,0,0h4.9h1.5h3.2c1.6,0,3-1.3,3-3v-3.2v-8V3.1 C22.4,1.5,21.1,0.2,19.5,0.2z M20.8,6.3c-0.1,0.1-0.3,0.3-0.4,0.3c-0.4,0.2-0.5,0.6-0.5,1.1c-0.1,2.8-1,5.3-2.8,7.4 c-2.1,2.5-4.8,3.7-8,4c-2.4,0.2-4.6-0.3-6.6-1.4c-0.1-0.1-0.3-0.2-0.4-0.3c2.1,0.1,4.1-0.4,5.9-1.7c-0.3,0-0.5-0.1-0.6-0.1 c-1.4-0.3-2.4-1-3-2.3c-0.2-0.4-0.1-0.4,0.3-0.4c0.4,0.1,0.9,0,1.3-0.1c-0.1-0.1-0.2-0.1-0.3-0.2C3.9,12.1,2.9,11,2.6,9.3 C2.6,8.9,2.6,8.8,3,9c0.4,0.2,0.9,0.3,1.3,0.3c0-0.2-0.1-0.2-0.2-0.2C2.7,7.8,2.2,5.9,3,4.2c0.1-0.3,0.2-0.3,0.4-0.1 C5.5,6.4,8,7.7,11,8c0.1,0,0.2,0,0.3,0c0.4,0,0.4,0,0.4-0.4c-0.2-1.7,0.7-3.3,2.1-4.1c1.5-0.8,3.4-0.6,4.7,0.6 c0.2,0.2,0.4,0.2,0.7,0.2c0.6-0.2,1.3-0.4,1.9-0.7c0.1,0,0.2-0.1,0.2-0.1c0.1,0.1,0,0.2,0,0.3c-0.3,0.6-0.6,1.1-1.1,1.5 c-0.1,0.1-0.2,0.2-0.3,0.3c0,0,0,0,0,0.1c0.7-0.1,1.4-0.3,2-0.5C21.5,5.6,21.2,6,20.8,6.3z"
});

var SvgTwitterIcon = function SvgTwitterIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.8 22.8",
    style: {
      enableBackground: "new 0 0 22.8 22.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitterIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter-icon.b376122b.svg";
export { ForwardRef as ReactComponent };